
const m = window.require("@glimmer/reference");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
